import React from 'react'
import LoaderDots from '../../../Modal/components/LoaderDots';
import Table from './PointsTable'

const WatchPoinst = (props) => {
  const { state } = props
  return (
    <>
      <div className='dots-height'>
        {state.loading && <LoaderDots />}
        {state.upload ? (state.uploadOk ? <div className='text-center green-color'>Cargado con exito</div> : <div className='text-center red-color'>Error en la acción</div>) : <></>}
      </div>
      {
        !!state.puntos.length &&
        <>
          <Table
            content={state.puntos}
            activePunto={props.activePunto}
            activeAllPuntos={props.activeAllPuntos}
            handlerDobleClick={props.handlerDobleClick}
            accept={props.accept}
            cancel={props.cancel}
            delete={props.delete}
          />
        </>
      }
    </>
  )
}

export default WatchPoinst;